import { useState, useCallback, useMemo } from "react";
import type { ReactNode } from "react";
import { BreadcrumbContext } from "./breadcrumbContext";

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [overrides, setOverridesState] = useState<Record<string, string>>({});

  const setOverrides = useCallback(function setOverrides(newOverrides: Record<string, string>) {
    setOverridesState(newOverrides);
  }, []);

  const value = useMemo(() => ({ overrides, setOverrides }), [overrides, setOverrides]);

  return (
    <BreadcrumbContext value={value}>
      {children}
    </BreadcrumbContext>
  );
}
